"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.2398 1.75738C9.10654 0.624109 7.59981 0 5.99716 0C4.3945 0 2.88777 0.624109 1.75454 1.75738C-0.584845 4.0968 -0.584845 7.90324 1.75454 10.2427C2.88777 11.3759 4.3945 12 5.99719 12C7.59985 12 9.10654 11.3759 10.2398 10.2426C11.373 9.10938 11.9972 7.60265 11.9972 6C11.9972 4.39735 11.373 2.89062 10.2398 1.75738ZM9.46839 9.47127C8.54119 10.3984 7.30843 10.9091 5.99719 10.9091C4.68592 10.9091 3.45315 10.3984 2.52592 9.47127C0.611882 7.5572 0.611882 4.44284 2.52592 2.52876C3.45312 1.60153 4.68588 1.09091 5.99716 1.09091C7.30843 1.09091 8.54119 1.60153 9.46839 2.52873C10.3956 3.45596 10.9062 4.68873 10.9062 6C10.9062 7.31127 10.3956 8.54404 9.46839 9.47127Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: "8.12109",
  y: "3.17163",
  width: "1",
  height: "7",
  rx: "0.5",
  transform: "rotate(45 8.12109 3.17163)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  width: "1",
  height: "7",
  rx: "0.5",
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 3.87891 3.17163)",
  fill: "currentColor"
}));
var _default = exports.default = SvgComponent;